import styled from 'styled-components';

const Card = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 0;
  width: 100%;
  max-width: 320px;
  min-height: 104px;
  padding: 16px;
  border: 2px dashed ${(props) => props.theme.colors.inactive};
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
  box-sizing: border-box;
  transition: border-color 0.2s, background 0.2s;

  &:hover {
    border-color: ${(props) => props.theme.colors.main_cta};
    background: ${(props) => props.theme.colors.main_cta_light};
  }
  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.main_cta};
  }

  @media (min-width: 400px) {
    width: auto;
    width: 213px;
    height: 104px;
    padding: 10px;
  }
`;

const PlusIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: ${(props) => props.theme.colors.outline};
  color: ${(props) => props.theme.colors.white};
  font-size: 24px;
  line-height: 1;
`;

const Label = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors.text};
  text-align: center;
`;

const SubLabel = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colors.inactive};
  text-align: center;
`;

export default {
  Card,
  PlusIcon,
  Label,
  SubLabel,
};
